export default __webpack_public_path__ + "static/media/lionel_has_an_idea.ba0edcad.jpg";